function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 0.173828,
  width: 25,
  height: 25,
  rx: 12.5,
  fill: "#F0FDF4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.2023 8.72913C17.3443 8.8712 17.4241 9.06386 17.4241 9.26474C17.4241 9.46562 17.3443 9.65828 17.2023 9.80034L11.1417 15.861C10.9996 16.003 10.8069 16.0828 10.6061 16.0828C10.4052 16.0828 10.2125 16.003 10.0704 15.861L7.04014 12.8306C6.90215 12.6878 6.82579 12.4964 6.82751 12.2978C6.82924 12.0991 6.90891 11.9091 7.04937 11.7687C7.18983 11.6282 7.37984 11.5485 7.57848 11.5468C7.77711 11.5451 7.96848 11.6214 8.11136 11.7594L10.6061 14.2541L16.1311 8.72913C16.2731 8.58711 16.4658 8.50732 16.6667 8.50732C16.8675 8.50732 17.0602 8.58711 17.2023 8.72913Z",
  fill: "#22C55E"
});

function SvgListCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListCheck);
export default __webpack_public_path__ + "static/media/list-check.068b8714.svg";
export { ForwardRef as ReactComponent };